// Route name constants
export const ROUTE_NAMES = {
  HOME: 'home',
  WORKSPACES: 'workspaces',
  WORKSPACE_DETAIL: 'workspace-detail',
  FLOOD_PARITY_BENCHMARK: 'flood-parity-benchmark',
  FLOOD_PHYSICS_VALIDATION: 'flood-physics-validation',
  FLOOD_TEXTURE_SMOKE_TEST: 'flood-texture-smoke-test',
  FLOOD_V2_PROBES: 'flood-v2-probes',
  FLOOD_V2_PERFORMANCE: 'flood-v2-performance',
  FLOOD_V2_ANALYSIS_PROBES: 'flood-v2-analysis-probes',
  FLOOD_ANALYSIS_VIZ_PROBES: 'flood-analysis-viz-probes',
  FLOOD_3D_PRODUCTION_SMOKE: 'flood-3d-production-smoke',
  FLOOD_PHASE5_CAMERA_PROBES: 'flood-phase5-camera-probes',
  FLOOD_FLUX_PARTICLE_PROBES: 'flood-flux-particle-probes',
  MVT_VECTOR_SMOKE: 'mvt-vector-smoke',
  SELECT_BY_LOCATION_SMOKE: 'select-by-location-smoke',
  VECTOR_SYMBOLOGY_SMOKE: 'vector-symbology-smoke',
  STYLE_DIALOG_SMOKE: 'style-dialog-smoke',
  NOT_FOUND: 'not-found',
} as const

// Route path config
export const ROUTE_PATHS = {
  DEFAULT: '',
  HOME: '/',
  WORKSPACES: 'workspaces',
  WORKSPACE_DETAIL: ':id',
  FLOOD_PARITY_BENCHMARK: '/dev/flood-parity-benchmark',
  FLOOD_PHYSICS_VALIDATION: '/dev/flood-physics-validation',
  FLOOD_TEXTURE_SMOKE_TEST: '/dev/flood-texture-smoke-test',
  FLOOD_V2_PROBES: '/dev/flood-v2-probes',
  FLOOD_V2_PERFORMANCE: '/dev/flood-v2-performance',
  FLOOD_V2_ANALYSIS_PROBES: '/dev/flood-v2-analysis-probes',
  FLOOD_ANALYSIS_VIZ_PROBES: '/dev/flood-analysis-viz-probes',
  FLOOD_3D_PRODUCTION_SMOKE: '/dev/flood-3d-production-smoke',
  FLOOD_PHASE5_CAMERA_PROBES: '/dev/flood-phase5-camera-probes',
  FLOOD_FLUX_PARTICLE_PROBES: '/dev/flood-flux-particle-probes',
  MVT_VECTOR_SMOKE: '/dev/mvt-vector-smoke',
  SELECT_BY_LOCATION_SMOKE: '/dev/select-by-location-smoke',
  VECTOR_SYMBOLOGY_SMOKE: '/dev/vector-symbology-smoke',
  STYLE_DIALOG_SMOKE: '/dev/style-dialog-smoke',
} as const

export default {
  default: ROUTE_PATHS.DEFAULT,
  home: ROUTE_PATHS.HOME,
}
